import {Component, Input, OnInit} from '@angular/core';

// models
import {Car} from "../../../shared/models/cars/car";

// date picker
import {AbstractControl, FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import _moment from 'moment';

const moment = _moment;

export const DATE_FORMAT = {
    parse: {
        dateInput: ['YYYY-MM-DD']
    },
    display: {
        dateInput: 'DD/MM/Y',
        monthYearLabel: 'DD MM Y',
        dateA11yLabel: 'DD MM Y',
        monthYearA11yLabel: 'DD MM Y',
    },
};

@Component({
    selector: 'app-car-form',
    templateUrl: './car-form.component.html',
    styleUrl: './car-form.component.scss',
    providers: [
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
        },
        {provide: MAT_DATE_FORMATS, useValue: DATE_FORMAT},
    ],
})
export class CarFormComponent implements OnInit {

    @Input() public editMode = false;
    @Input() public car!: Car;

    public isLoading = false;
    public carForm!: FormGroup;

    public production_date = new FormControl<_moment.Moment | null>(moment());
    public inspection_date = new FormControl<_moment.Moment | null>(moment());
    public insurance_end_date = new FormControl<_moment.Moment | null>(moment());

    public registrationNumberMinLength = 2;
    public registrationNumberMaxLength = 10;
    public carBrandMinLength = 2;
    public carBrandMaxLength = 40;
    public carVinMinLength = 2;
    public carVinMaxLength = 100;
    public descriptionMinLength = 3;
    public descriptionMaxLength = 400;

    constructor(protected formBuilder: FormBuilder) {
    }

    ngOnInit(): void {
        this.buildCarForm();
        this.setCurrentDateTime();
        if (this.editMode) {
            this.isLoading = true;
            setTimeout((): void => {
                this.setCar(this.car);
                this.isLoading = false;
            }, 500);
        }
    }

    public get registrationNumber(): AbstractControl {
        return this.carForm.controls['registration_number'];
    }

    public get carBrand(): AbstractControl {
        return this.carForm.controls['car_brand'];
    }

    public get carVin(): AbstractControl {
        return this.carForm.controls['car_vin'];
    }

    public get productionDate(): AbstractControl {
        return this.carForm.controls['production_date'];
    }

    public get inspectionDate(): AbstractControl {
        return this.carForm.controls['inspection_date'];
    }

    public get insuranceEndDate(): AbstractControl {
        return this.carForm.controls['insurance_end_date'];
    }

    public get description(): AbstractControl {
        return this.carForm.controls['description'];
    }

    public setCurrentDateTime(): void {
        this.production_date.setValue(moment());
        this.inspection_date.setValue(moment());
        this.insurance_end_date.setValue(moment());
        this.productionDate.setValue(moment()?.format('YYYY-MM-DD'));
        this.inspectionDate.setValue(moment()?.format('YYYY-MM-DD'));
        this.insuranceEndDate.setValue(moment()?.format('YYYY-MM-DD'));
    }

    public setProductionDate(): void {
        this.productionDate.setValue(this.production_date.getRawValue()?.format('YYYY-MM-DD'));
    }

    public setInspectionDate(): void {
        this.inspectionDate.setValue(this.inspection_date.getRawValue()?.format('YYYY-MM-DD'));
    }

    public setInsuranceEndDate(): void {
        this.insuranceEndDate.setValue(this.insurance_end_date.getRawValue()?.format('YYYY-MM-DD'));
    }

    private buildCarForm(): void {
        this.carForm = this.formBuilder.group({
            registration_number: ['', {
                validators: [Validators.required,
                    Validators.minLength(this.registrationNumberMinLength), Validators.maxLength(this.registrationNumberMaxLength)]
            }],
            car_brand: ['', {
                validators: [Validators.required,
                    Validators.minLength(this.carBrandMinLength), Validators.maxLength(this.carBrandMaxLength)]
            }],
            car_vin: ['', {
                validators: [Validators.minLength(this.carVinMinLength), Validators.maxLength(this.carVinMaxLength)]
            }],
            production_date: ['', {validators: [Validators.required]}],
            inspection_date: ['', {validators: [Validators.required]}],
            insurance_end_date: ['', {validators: [Validators.required]}],
            description: ['', {
                validators: [Validators.minLength(this.descriptionMinLength), Validators.maxLength(this.descriptionMaxLength)]
            }],
        });
    }

    private setCar(car: Car): void {
        const {...formData} = car;
        this.carForm.patchValue(formData);
        if (car.car_vin) {
            this.carVin.setValue(car.car_vin);
        } else this.carVin.setValue('');
        this.production_date.setValue(moment(car.production_date));
        this.inspection_date.setValue(moment(car.inspection_date));
        this.insurance_end_date.setValue(moment(car.insurance_end_date));
        if (car.description) {
            this.description.setValue(car.description);
        } else this.description.setValue('');
    }
}
